import ModalComponent from '../../components/ModalComponent';

interface Props {
  open: boolean
  pageTitle: string
  isPublished?: boolean
  handleClose: () => void
  handleSave: () => void
}

const Index = (props: Props) => {
  const {
    open, pageTitle, isPublished, handleClose, handleSave,
  } = props;

  return (
    <>
      <ModalComponent
        title={isPublished ? 'エラー' : 'ページ削除'}
        confirmButtonText="削除する"
        confirmButtonColor="danger"
        hideConfirmButton={!!isPublished}
        cancelButtonText={isPublished ? '閉じる' : 'キャンセル'}
        footerClass="justify-content-center"
        cancelButtonColor="outline-secondary"
        onConfirm={handleSave}
        show={open}
        closeModal={handleClose}
        centered
        animation={false}
      >
        {isPublished
          ? (<p className="mb-0 text-center">公開中のページは削除することができません。</p>)
          : (
            <p className="mb-0">
              「
              {pageTitle}
              」を削除してもよろしいですか？
            </p>
          )}
      </ModalComponent>
    </>
  );
};

export default Index;
